import { render, staticRenderFns } from "./ReceiveSave.vue?vue&type=template&id=3e2f713b&"
import script from "./ReceiveSave.vue?vue&type=script&lang=js&"
export * from "./ReceiveSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports